import { IJobCategory } from "../../../models/JobCategory";

export function getCategoryIdByName(
    categories: IJobCategory[],
    name: string
  ): string | null {
    if (!name) return null;
  
    const found = categories.find(
      (c) => c.categoryName.trim().toLowerCase() === name.trim().toLowerCase()
    );
  
    return found?._id ?? null;
  }